import { HeaderService } from '@patsnap-utils/biz'
import { reactive } from 'vue';

// TODO: FIXME
export const headerService: HeaderService = reactive<any>(new HeaderService());
headerService.visibleProducts = false
